module.exports = __webpack_public_path__ + "assets/e7bd48de8dd3278f3bc22c7222e51bbd.woff";